import { sales } from "@obby/constants";

export default function Course__IsOnSales(course) {
  return sales && !course.excludeFromSales;
}
